var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5163 13.2074V13.4113L14.6589 13.557L16.188 15.1207V15.2715H3.81458V15.1207L5.34373 13.557L5.48626 13.4113V13.2074V8.9339C5.48626 6.46865 6.75552 4.53107 8.86566 4.01804L9.24754 3.92519V3.53219V2.951C9.24754 2.50716 9.59415 2.16895 10.0013 2.16895C10.4084 2.16895 10.7551 2.50716 10.7551 2.951V3.53219V3.92552L11.1373 4.01813C13.2544 4.53105 14.5163 6.47578 14.5163 8.9339V13.2074ZM13.3447 14.5621H13.8447V14.0621V8.9339C13.8447 7.77873 13.5009 6.69854 12.8389 5.89743C12.1696 5.08756 11.1932 4.58775 10.0013 4.58775C8.80945 4.58775 7.83305 5.08756 7.16374 5.89743C6.50167 6.69854 6.15794 7.77873 6.15794 8.9339V14.0621V14.5621H6.65794H13.3447ZM11.0675 17.1262C10.8805 17.5469 10.4662 17.8356 10.0013 17.8356C9.53636 17.8356 9.12214 17.5469 8.93508 17.1262H11.0675ZM2.20554 8.00655C2.43397 5.79584 3.49812 3.84423 5.07493 2.47475L5.55965 2.9704C4.83434 3.58512 4.2271 4.33379 3.77034 5.17845C3.29635 6.05498 2.99478 7.01569 2.88052 8.00655H2.20554ZM14.4483 2.97073L14.9282 2.4765C16.4974 3.84575 17.5608 5.79657 17.7955 8.00655H17.1213C17.0058 7.01732 16.7045 6.05823 16.2323 5.18245C15.7767 4.33752 15.1713 3.58776 14.4483 2.97073Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.82d10ac403d6a3842809fb62d287ce6e.svg";
export { ForwardRef as ReactComponent };